import React, { ReactNode, useState } from 'react'

import TickButton from './TickButton'

interface IToggleButton {
  title?: string
  initialEnabled: boolean
  onChange?: ((enabled: boolean) => void) | null
  children?: ReactNode
  style?: {
    width?: string
  }
}

function ToggleButton({
  title,
  initialEnabled = false,
  onChange = null,
  children,
  style = {},
}: IToggleButton) {
  const [enabled, setEnabled] = useState(initialEnabled)

  function onPress() {
    if (onChange) {
      onChange(!enabled)
    }

    setEnabled(!enabled)
  }

  return (
    <TickButton
      title={title}
      enabled={enabled}
      showTick={false}
      onPress={onPress}
      style={style}
    >
      {children}
    </TickButton>
  )
}

export default ToggleButton
